<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <slot />
    <div
      v-if="description"
      class="mt-2 w-full font-sans text-xs leading-normal text-black prose-a:text-blue prose-a:no-underline hover:prose-a:text-blue-dark lg:text-sm lg:leading-relaxed"
      v-html="description"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  description: String,
});
</script>
